// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"a8d4a084","875":"bc9f7926"}[chunkId] + ".chunk.js";
};